/* ============================================================
   MICTLÁN — Mega menús de escritorio de mx-header
   ============================================================
   Marcado (sections/mx-header.liquid):
   · [data-mx-mega-raiz]             el header (el mouse sale de aquí → cierra)
   · [data-mx-mega-item]             <li> con el botón y su panel
   · [data-mx-mega-abrir]            botón con aria-controls="<id del panel>"
   · [data-mx-mega-panel]            panel (atributo hidden cuando está cerrado)
   · [data-mx-pestana][role="tab"]   pestañas dentro de un panel
   Abre con clic, con Enter/Espacio y al pasar el mouse (solo en equipos
   con mouse). Cierra con Esc (regresa el foco al botón), con clic fuera,
   al sacar el mouse del header o al salir con el foco.
   Delegado en document: sigue funcionando si el customizer recarga la
   sección.
   ============================================================ */
(function () {
  'use strict';
  if (window.__mxMegaMenu) return;
  window.__mxMegaMenu = true;

  var conMouse = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)');
  var temporizador = null;
  var abiertoPorMouse = 0;

  function panelDe(boton) {
    return document.getElementById(boton.getAttribute('aria-controls'));
  }

  function cerrar(boton) {
    var panel = panelDe(boton);
    boton.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  }

  function cerrarTodos(excepto) {
    document.querySelectorAll('[data-mx-mega-abrir][aria-expanded="true"]').forEach(function (b) {
      if (b !== excepto) cerrar(b);
    });
  }

  function abrir(boton) {
    var panel = panelDe(boton);
    if (!panel) return;
    cerrarTodos(boton);
    boton.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  function seleccionarPestana(tab) {
    var lista = tab.closest('[role="tablist"]');
    if (!lista || tab.getAttribute('aria-selected') === 'true') return;
    lista.querySelectorAll('[role="tab"]').forEach(function (t) {
      var activa = t === tab;
      t.setAttribute('aria-selected', activa ? 'true' : 'false');
      t.setAttribute('tabindex', activa ? '0' : '-1');
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !activa;
    });
  }

  /* ---- Clic ---- */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-mx-mega-abrir]');
    if (boton) {
      var abierto = boton.getAttribute('aria-expanded') === 'true';
      // Si el mouse lo acaba de abrir, el clic no lo cierra.
      if (abierto && Date.now() - abiertoPorMouse > 400) cerrar(boton);
      else abrir(boton);
      return;
    }
    var tab = e.target.closest('[data-mx-pestana]');
    if (tab) {
      seleccionarPestana(tab);
      return;
    }
    if (!e.target.closest('[data-mx-mega-item]')) cerrarTodos();
  });

  /* ---- Mouse ---- */
  document.addEventListener('mouseover', function (e) {
    if (!conMouse.matches) return;
    var raiz = e.target.closest('[data-mx-mega-raiz]');
    if (!raiz) return;
    clearTimeout(temporizador);

    var boton = e.target.closest('[data-mx-mega-abrir]');
    if (boton) {
      if (boton.getAttribute('aria-expanded') !== 'true') {
        abrir(boton);
        abiertoPorMouse = Date.now();
      }
      return;
    }
    var tab = e.target.closest('[data-mx-pestana]');
    if (tab) {
      seleccionarPestana(tab);
      return;
    }
    // Otro enlace o ícono de la barra: cierra el panel abierto.
    if (e.target.closest('[data-mx-mega-fila] a, [data-mx-mega-fila] button') && !e.target.closest('[data-mx-mega-panel]')) {
      cerrarTodos();
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!conMouse.matches) return;
    var raiz = e.target.closest('[data-mx-mega-raiz]');
    if (!raiz || (e.relatedTarget && raiz.contains(e.relatedTarget))) return;
    clearTimeout(temporizador);
    temporizador = setTimeout(function () {
      cerrarTodos();
    }, 200);
  });

  /* ---- Teclado y foco ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var abierto = document.querySelector('[data-mx-mega-abrir][aria-expanded="true"]');
      if (abierto) {
        cerrar(abierto);
        abierto.focus();
      }
      return;
    }
    var tab = e.target.closest && e.target.closest('[data-mx-pestana]');
    if (tab && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
      var i = tabs.indexOf(tab) + (e.key === 'ArrowDown' ? 1 : -1);
      var siguiente = tabs[(i + tabs.length) % tabs.length];
      seleccionarPestana(siguiente);
      siguiente.focus();
      e.preventDefault();
    }
  });

  document.addEventListener('focusout', function (e) {
    var item = e.target.closest && e.target.closest('[data-mx-mega-item]');
    if (!item || !e.relatedTarget || item.contains(e.relatedTarget)) return;
    var boton = item.querySelector('[data-mx-mega-abrir]');
    if (boton && boton.getAttribute('aria-expanded') === 'true') cerrar(boton);
  });
})();
